module.exports = __webpack_public_path__ + "static/media/4.be1298af.jpg";